import styled from 'styled-components'

import { Button as AntButton } from 'src/components/Ant'
import { Switch as FormikSwitch } from 'src/components/Formik'
import Text from 'antd/lib/typography/Text'

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`

export const DrawerFooterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`

export const Switch = styled(FormikSwitch)`
  width: 5rem;
`

export const SwitchContainer = styled.div`
  display: flex;
`

export const TextInfo = styled(Text)`
  font-size: small;
  line-height: 2.5rem;
  margin-left: 0.5rem;
`
